import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { environment } from '@env/environment';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Main } from '../core/main.service';

@Injectable({
    providedIn: 'root'
})
export class EkubService {
    constructor(private httpClient: HttpClient, private mainService: Main, @Inject(Restangular) public Restangular: any) {
    }

    getEkubs(options: string) {
        return this.Restangular.one('ekubs?' + options).customGET('');
    }

    getAllEkubs(options: string = null) {
        debugger;
        return this.Restangular.one('ekubs?all=true' + options).customGET('');
    }

    getEkubMembersList(id: String, currentPage: number, filter: String = null) {
        debugger;
        return this.Restangular.one('ekubs/' + id + '/members?page=' + currentPage + filter).customGET('');
    }

    getEkubTransactionsList(id: String, currentPage: number, filter: String = null) {
        debugger;
        return this.Restangular.one('transactions/ekub/' + id + '?page=' + currentPage + filter).customGET('');
    }

    updateMembership(dto: any) {
        debugger;
        return this.Restangular.one('ekubs/member/status').customPUT(dto);
    }

    deactivateMember(id: string, status: string) {
        debugger;
        if (status == 'inactive') {
            return this.Restangular.one('ekubs/member/' + id + '/deactivate').customPUT({});
        }
        return this.Restangular.one('ekubs/member/' + id + '/reactivate').customPUT({});
    }

    getBranches(filter: String = null) {
        debugger;
        return this.Restangular.one('branches' + filter).customGET('');
    }

    syncRatings(id: string,) {
        debugger;
        var dto = {};
        return this.Restangular.one('ekubs/' + id + '/syncratings').customPUT(dto);
    }

    syncMembership(id: string,) {
        debugger;
        var dto = {};
        return this.Restangular.one('ekubs/' + id + '/syncmembership').customPUT(dto);
    }

    getEkubMembers(id: String) {
        debugger;
        return this.Restangular.one('ekubs/' + id + '/members').customGET('');
    }

    getEkub(id: string) {
        return this.Restangular.one('ekubs/' + id).customGET('');
    }

    getEkubByCategory(options: string) {
        return this.Restangular.one('ekubs/category?' + options).customGET('');
    }

    createEkub(ekub: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('ekubs/' + id).customPUT(ekub);
        }
        return this.Restangular.one('ekubs').customPOST(ekub);
    }

    getAllCategories(options: string = null) {
        debugger;
        return this.Restangular.one('categories?all=true' + options).customGET('');
    }

    getCategories(page: number = null, options: string) {
        return this.Restangular.one('categories?' + options).customGET('');
    }

    getCategory(id: string) {
        return this.Restangular.one('categories/category?' + id).customGET('');
    }

    changeEkubStatus(id: string, status: string) {
        return this.Restangular.one(`ekubs/ekub/${id}/${status}`).customPUT('');
    }

    createCategory(category: object, id: string) {
        if (id != null) {
            return this.Restangular.one('categories/' + id).customPUT(category);
        }
        return this.Restangular.one('categories').customPOST(category);
    }

    getAllBanks(options: string = null) {
        debugger;
        return this.Restangular.one('accounts?all=true' + options).customGET('');
    }

    getBankAccounts(accronym: string = null) {
        debugger;
        return this.Restangular.one('accounts/bank/' + accronym).customGET('');
    }

    getAwards(page: number = null, options: string) {
        return this.Restangular.one('awards?page=' + page + options).customGET('');
    }

    getAward(id: string, filter: string) {
        return this.Restangular.one('awards/' + id + filter).customGET('');
    }

    createAward(award: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('awards/' + id).customPUT(award);
        }
        return this.Restangular.one('awards').customPOST(award);
    }

    changeAwardStatus(id: string, status: string) {
        return this.Restangular.one(`awards/${id}/${status}`).customPUT('');
    }

    public upload(data, id) {
        var url = environment.production
            ? environment.ONLINE_BASE_URL :
            environment.LOCAL_BASE_URL;
        let uploadURL = `${url}api/file/cars/${id}`;
        return this.httpClient.post<any>(uploadURL, data, {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') },
            reportProgress: true,
            observe: 'events'
        }).pipe(map((event) => {

            switch (event.type) {

                case HttpEventType.UploadProgress:
                    const progress = Math.round(100 * event.loaded / event.total);
                    return { status: 'progress', message: progress };

                case HttpEventType.Response:
                    return event.body;
                default:
                    //return `Unhandled event: ${event.type}`;
                    return {
                        status: 'unhandeled event', message: `${event.type}`
                    };
            }
        })
        ).toPromise();
    }

    fetchUsers(searchTerm: string) {
        debugger;
        return this.Restangular.one('users/search/' + searchTerm).customGET('');
    }

    getUserStats(user: string) {
        debugger;
        return this.Restangular.one('ekubs/user/' + user + '/ekubs/stat').customGET('');
    }

    drawAward(award: string) {
        debugger;
        console.log(award);
        return this.Restangular.one('awards/' + award + '/draw').customPUT(award);
    }


    getGuarantees(page: number = null, options: string) {
        return this.Restangular.one('guarantees?page=' + page + options).customGET('');
    }

    getGuarantee(id: string) {
        return this.Restangular.one('guarantees/' + id).customGET('');
    }

    createGuarantee(guarantee: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('guarantees/' + id).customPUT(guarantee);
        }
        return this.Restangular.one('guarantees').customPOST(guarantee);
    }

    changeGuaranteeStatus(id: string, status: string) {
        return this.Restangular.one(`guarantees/${id}/${status}`).customPUT('');
    }

}
